var _rect, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTestPassed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 73,
    height: 73,
    viewBox: "0 0 73 73",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 73,
    height: 73,
    fill: "url(#pattern0)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_575_456",
    transform: "scale(0.0104167)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_575_456",
    width: 96,
    height: 96,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGAAAABgCAYAAADimHc4AAAACXBIWXMAAAsTAAALEwEAmpwYAAACw0lEQVR4nO2dzWoUQRRGexVXiRj8i6+QuPEZxJVBwuAjCD6APkaCSlTcic/gUl27cBeF4DLZiaImUUQiRwproWHomZ4p79c/34HeDDNd997TdHVPX7qqyhhjjOkAwCXgLvAc2AO+5W0vf3YHWFHH2TuAFeAZ8JPJpO88BS6q4+4FwA3gC835DKyr4+80wG3gF7OTfntLnUcnAdaBY+Yn7eO6Op9OAZwFPlCOj8B5dV6dAXhCeR6r8+oEwDng+38Q8AO4UPUN4DJwH3gLHBHDHjACFvO2AewGjX2Uc70HrCkLfwp4NOdVyqzFXx4TzzKwTywp94fAgqL4r9Awqonrpiiml6ES0oSGjsWauJaEcW1HnvOjTzvTCjiNjnS/sRohIE0+SjZqYksTs5KtCAHvxEnu1kzC78Wx7UQIOEDPfp5wl/I2akHxEwcRAkwNFiDGAsRYgBgLEGMBYixAjAWIsYAyvAGuAp+a/tACyhT/TL7pvNJUggUUKv5fd/6NJFhAweLPIsECChe/qQQLaM7r9CBnyj8ir03amQUUPvJPPG1LsmqxAGHxWylAHU81//6nLr4FjCGy+POON21QjVDHUwUW3wLGEFn8WcdrGlyrAqLw+PMU3wLGEFn8puPNRNsCotD4JYofkW8vBVCo+BH5ui9oAhYgxgLEWIAYCxBjAWIsQIwFiLGAMrgvSIj7goS4L0iI+4KEuC9IiPuChLgvSIj7gkowqcoF9u++IJUA9wUJBbgvSCjAfUFCAe4LEgpwX5BQgPuChALcF9QjKvURN3QqC9BiAWIsQIwFiLEAMRYwAAGH6iRbzNchvLq4zewM4eXdbWYzQsBaoeWl+kbM6+uzhLRsh/mXByHFzwIW8rId5g8vFOvIJAnbAz8dHacjP7z4J0SsppUj0hXAQC5RD3OuW2HnfGOMMcYYY4wxxhhT9YHf80UiL4+FlXMAAAAASUVORK5CYII="
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTestPassed);
export default __webpack_public_path__ + "static/media/TestPassed.15782e4444d11edc9af81f6c40b0ba79.svg";
export { ForwardRef as ReactComponent };